import $ from 'jquery';
import Swiper from 'swiper';

export default class NewsSlider {
	constructor() {
		this.elSelector = '.news-slider';
		this.nextSelector = `${this.elSelector}__button_next`;
		this.prevSelector = `${this.elSelector}__button_prev`;
		this.paginationSelector = `${this.elSelector}__pagination`;
		this.windwoWidth = $(window).width();
	}

	init() {
		const {
			elSelector,
			nextSelector,
			prevSelector,
			paginationSelector
		} = this;

		const settings = {
			slidesOffsetBefore: 0,
			slidesPerView: 1,
			spaceBetween: 0,
			pagination: {
				el: paginationSelector,
				type: 'fraction'
			},
			navigation: {
				nextEl: nextSelector,
				prevEl: prevSelector
			}
		};

		return new Swiper(elSelector, {
			breakpoints: {
				// mobile
				767: {
					slidesPerView: 'auto',
					CSSWidthAndHeight: true,
					centeredSlides: true,
					spaceBetween: 16,
					pagination: {
						el: paginationSelector
					}
				},
				// tablet
				1239: {
					...settings
				},
				// desktop
				9999: {
					...settings,
					noSwiping: true,
					noSwipingClass: 'no-swiping'
				}
			}
		});
	}

	makeSlider() {
		if ($(this.elSelector).length) {
			let newsSlider = this.init();

			window.addEventListener('resize', () => {
				if (this.windwoWidth === $(window).width()) {
					return;
				} // handle mobile browsers viewport changes

				if (!newsSlider.destroyed) {
					if (Array.isArray(newsSlider)) {
						newsSlider.forEach(instance => {
							instance.destroy();
						});
					}
					else {
						newsSlider.destroy();
					}
				}

				this.windwoWidth = $(window).width();
				newsSlider = this.init();
			});
		}
	}
}



// WEBPACK FOOTER //
// ./app/blocks/news-slider/index.js